import * as React from 'react';
import data from '../images/data_relationships.jpg';

export class Data extends React.Component {

    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="App">
                <img src={data} alt="Data image" height={600} width={900} />
            </div>
        );
    }

}